import React, { useContext } from "react";
import { faUserPlus } from "@fortawesome/free-solid-svg-icons";
import useSWR from "swr";
import DashboardContenLeftMenus from "./DashboardContenLeftMenus";
import DashboardContentHeader from "./DashboardContentHeader";
import DashboardContentFooter from "./DashboardContentFooter";
import TopActionMenus from "./TopActionMenus";
import { NavigationContext } from "navigation-react";
import LoaderAnimation from "./LoaderAnimationLarge";
import SecureLS from "secure-ls";
const ls = new SecureLS({ encodingType: "aes" });

const username = ls.get("username");
const userpw = ls.get("userpw");

const fetcher = (url) =>
  fetch(url, {
    credentials: "same-origin",
    mode: "same-origin",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Basic ${btoa(`${username}:${userpw}`)}`,
    },
  }).then((res) => {
    return res.json();
  });

const UserRegister = () => {
  const { stateNavigator } = useContext(NavigationContext);
  const { data: users, error } = useSWR("/user-register-api", fetcher);

  if (!users && !error) return <LoaderAnimation />;
  if (error)
    return (
      <LoaderAnimation loadingTxt="Failed to load patient register. Please try again." />
    );

  return (
    <div className="dashboard-container">
      <DashboardContentHeader />
      <div className="content-wrapper">
        <DashboardContenLeftMenus />
        <div className="patient-register">
          <TopActionMenus
            addLabel="Add User"
            faUsersIcon={faUserPlus}
            stateKey="adduserregister"
            AddTitle="User Register"
          />
          {users?.length > 0 ? (
            <table className="table">
              <thead>
                <tr>
                  <td>Full Name</td>
                  <td>Username</td>
                  <td>Specialty</td>
                  <td>Contact number</td>
                  <td>Email</td>
                  <td>Created</td>
                  <td>Role</td>
                  <td>Edited Date</td>
                  <td>Status</td>
                  <td>Actions</td>
                </tr>
              </thead>
              <tbody>
                {(users || []).map((user) => (
                  <tr key={user.uid}>
                    <td>{user?.field_doctor_referer_full_name}</td>
                    <td>{user?.name}</td>
                    <td>{user?.field_specialty}</td>
                    <td>{user?.field_doctor_ref_contact_number}</td>
                    <td>{user?.mail}</td>
                    <td>{user?.created}</td>
                    <td>{user?.roles_target_id}</td>
                    <td>{user?.changed}</td>
                    <td>{user?.status}</td>
                    <td className="formActionBtn">
                      <button
                        onClick={() =>
                          stateNavigator.navigate("edituserregister", {
                            userId: user?.uid,
                            userDoctorFullName:
                              user?.field_doctor_referer_full_name,
                            userDoctorContactNumber:
                              user?.field_doctor_ref_contact_number,
                            userSpecialty: user?.field_specialty,
                            userName: user?.name,
                            userEmail: user?.mail,
                            userStatus: user?.status,
                          })
                        }
                      >
                        Edit
                      </button>
                      <button
                        onClick={() =>
                          stateNavigator.navigate("deleteuserregister", {
                            userDetails: [
                              user.uid,
                              user.field_doctor_referer_full_name,
                            ],
                          })
                        }
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <LoaderAnimation loadingTxt="Users yet to be registered" />
          )}
        </div>
      </div>
      <DashboardContentFooter />
    </div>
  );
};

export default UserRegister;
